"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconCopy', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M6 0.793457C5.44772 0.793457 5 1.24117 5 1.79346V3.79346H3C2.44772 3.79346 2 4.24117 2 4.79346V13.7935C2 14.3457 2.44772 14.7935 3 14.7935H10C10.5523 14.7935 11 14.3457 11 13.7935V11.7935H13C13.5523 11.7935 14 11.3457 14 10.7935V1.79346C14 1.24117 13.5523 0.793457 13 0.793457H6ZM11 9.79346H12V2.79346H7V3.79346H10C10.5523 3.79346 11 4.24117 11 4.79346V9.79346ZM4 12.7935V5.79346H9V12.7935H4Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M8 0.793457C7.44772 0.793457 7 1.24117 7 1.79346V4.79346H4C3.44772 4.79346 3 5.24117 3 5.79346V17.7935C3 18.3457 3.44772 18.7935 4 18.7935H12C12.5523 18.7935 13 18.3457 13 17.7935V14.7935H16C16.5523 14.7935 17 14.3457 17 13.7935V1.79346C17 1.24117 16.5523 0.793457 16 0.793457H8ZM13 12.7935H15V2.79346H9V4.79346H12C12.5523 4.79346 13 5.24117 13 5.79346V12.7935ZM5 16.7935V6.79346H11V16.7935H5Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M9.99988 1.79346C9.44759 1.79346 8.99988 2.24117 8.99988 2.79346V5.79346H4.99988C4.44759 5.79346 3.99988 6.24117 3.99988 6.79346V20.7935C3.99988 21.3457 4.44759 21.7935 4.99988 21.7935H13.9999C14.5522 21.7935 14.9999 21.3457 14.9999 20.7935V17.7935H18.9999C19.5522 17.7935 19.9999 17.3457 19.9999 16.7935V2.79346C19.9999 2.24117 19.5522 1.79346 18.9999 1.79346H9.99988ZM14.9999 15.7935H17.9999V3.79346H10.9999V5.79346H13.9999C14.5522 5.79346 14.9999 6.24117 14.9999 6.79346V15.7935ZM5.99988 7.79346V19.7935H12.9999V7.79346H5.99988Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M12.5075 1.79348C12.1084 1.79149 11.7249 1.94864 11.442 2.23016C11.1591 2.51168 11 2.89434 11 3.29346V7.79384L6.5 7.79346C6.10216 7.79342 5.72059 7.95144 5.43926 8.23275C5.15793 8.51406 4.99988 8.89561 4.99988 9.29346V28.2924C4.99988 29.1207 5.67137 29.7923 6.49975 29.7924L19.4998 29.7935C19.8976 29.7935 20.2792 29.6355 20.5605 29.3542C20.8418 29.0729 20.9999 28.6913 20.9999 28.2935V23.7935H25.5C26.3284 23.7935 27 23.1219 27 22.2935V3.35815C27 2.53264 26.333 1.86228 25.5075 1.85817L12.5075 1.79348ZM20.9999 20.7935H24V4.85071L14 4.80094V7.79409L19.5 7.79456C20.3284 7.79463 20.9999 8.46618 20.9999 9.29456V20.7935ZM7.99988 26.7925V10.7936L17.9999 10.7944V26.7933L7.99988 26.7925Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;